export default __webpack_public_path__ + "static/media/elf-02.2b969d2d.jpg";